import React from 'react';

import { CommunityName } from 'components/AiCompetitiveIntelligence/AiCiTableWrapper';

type Props = {
  name: string;
};

const CommunityNameCell = ({ name }: Props) => <CommunityName>{name}</CommunityName>;

export default CommunityNameCell;
